import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IOfferCard, IOfferCardFormData } from '../models';

@Injectable()
export class CompanyProfileCardResolve implements Resolve<any> {

  constructor(private _http: HttpClient) { }

  resolve(route: ActivatedRouteSnapshot): Observable<IOfferCard> {
    return this._http.get(`api/settings/companyProfile`) as Observable<IOfferCard>;
  }
}
